const ACTION_PREFIX = '@NAVIGATION/';
export const GET_NODE_TREE = `${ACTION_PREFIX}_GET_NODE_TREE`;
export const SET_NODE_TREE = `${ACTION_PREFIX}_SET_NODE_TREE`;
export const GET_NODE_TREE_ERROR = `${ACTION_PREFIX}_GET_NODE_TREE_ERROR`;
